export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20glass%20and%20polished%20aluminum%20surfaces%20intersecting%20with%20soft%20diffused%20studio%20lighting%2C%20warm%20cream%20and%20charcoal%20tones%2C%20minimalist%20precision%20engineering%20aesthetic%2C%20clean%20architectural%20lines%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20abstract%20material%20study%2C%20high%20contrast%20between%20light%20and%20dark%20surfaces%2C%20sophisticated%20industrial%20design%20photography&width=1800&height=1200&seq=hero-bg-technopankai&orientation=landscape"
          alt="Abstract precision engineering surfaces with glass and aluminum materials"
          title="TECHNOPANKAI, MB engineering aesthetic"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-10 md:mb-14">
          <div className="w-16 h-[2px] bg-accent-400/60 mx-auto mb-8"></div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 tracking-tight leading-none">
            TECHNOPANKAI, MB
          </h1>
        </div>

        <p className="font-body text-base md:text-lg text-background-100/90 max-w-[640px] mx-auto leading-relaxed">
          A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
        </p>

        <div className="mt-16 md:mt-20 flex items-center justify-center gap-8">
          <div className="flex items-center gap-3 text-background-200/70">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-check-double-line text-lg"></i>
            </div>
            <span className="font-label text-sm tracking-wide uppercase">Precision Engineering</span>
          </div>
          <div className="w-px h-8 bg-background-200/30"></div>
          <div className="flex items-center gap-3 text-background-200/70">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-stack-line text-lg"></i>
            </div>
            <span className="font-label text-sm tracking-wide uppercase">Modern Architecture</span>
          </div>
          <div className="w-px h-8 bg-background-200/30"></div>
          <div className="flex items-center gap-3 text-background-200/70">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-shield-check-line text-lg"></i>
            </div>
            <span className="font-label text-sm tracking-wide uppercase">Long-Term Quality</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 flex justify-center">
        <div className="w-6 h-10 border-2 border-background-200/30 rounded-full flex items-start justify-center pt-2">
          <div className="w-1.5 h-1.5 bg-accent-400/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}